import request from '@/utils/request'
const server = "/business"
import Vue from 'vue'
// const server = Vue.prototype.portal

//健康档案统计报表
export function getEhrData(query) {
  return request({
    url: server+'/report/weixinEhr',
    method: 'post',
    data: query
  })
}

//健康档案列表
export function getEhrList(query, pageNum, pageSize) {
  return request({
    url: server+'/ehr/search?page='+ pageNum + '&pageSize=' + pageSize,
    method: 'post',
    data: query
  })
}

//获取糖尿病风险评估列表
export function getPatientEasyillDiabetsList(reqParam, pageNum, pageSize) {
  return request({
    url: server+'/patientEasyillDiabets/list?page='+ pageNum + '&pageSize=' + pageSize,
    method: 'post',
    data: reqParam
  })
}

//新增糖尿病风险评估
export function addPatientEasyillDiabetsModel(reqParam) {
  return request({
    url: server+'/patientEasyillDiabets/add',
    method: 'post',
    data: reqParam
  })
}

//新增糖尿病心血管风险评估
export function addPatientEasyillAscvdDiabets(params) {
  return request({
    url: '/business//patientEasyillAscvdDiabets/add',
    method: 'post',
    data: params
  })
}

//一键通
export function getPtientHealthunionTalkList(reqParam, pageNum, pageSize) {
  return request({
    url: server+'/patientHealthunionTalk/list?page='+ pageNum + '&pageSize=' + pageSize,
    method: 'post',
    data: reqParam
  })
}

//添加处理
export function dealPtientHealthunionTalk(reqParam) {
  return request({
    url: server+'/patientHealthunionTalk/deal',
    method: 'post',
    data: reqParam
  })
}
